import { useRequest } from "hooks";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { IbanXsBanksRecipientsPivot, IbanXsBanksRecipientsPivotResponse } from "../types";
import {
    getIbanXsBanksRecipientsPivotThunk,
    updateIbanXsBanksRecipientsPivotThunk,
    deleteIbanXsBanksRecipientsPivotThunk,
    createIbanXsBanksRecipientsPivotThunk
} from "../thunks";
import { changeExportIbanXsBanksRecipientsPivotLoading as changeExportLoading } from "../slice";

export const useIbanXSBanksRecipientsPivotActions = () => {
    const getIbanXSBanksRecipientsPivot = useRequest<
        ThunkReturnType<IbanXsBanksRecipientsPivotResponse>,
        string | undefined
    >({
        thunk: getIbanXsBanksRecipientsPivotThunk
    });

    const createIbanXSBanksRecipientsPivot = useRequest<
        ThunkReturnType<ResourceResponse<IbanXsBanksRecipientsPivot>>,
        Partial<IbanXsBanksRecipientsPivot>
    >({
        thunk: createIbanXsBanksRecipientsPivotThunk
    });

    const updateIbanXSBanksRecipientsPivot = useRequest<
        ThunkReturnType<ResourceResponse<IbanXsBanksRecipientsPivot>>,
        Partial<IbanXsBanksRecipientsPivot>
    >({
        thunk: updateIbanXsBanksRecipientsPivotThunk
    });

    const deleteIbanXSBanksRecipientsPivot = useRequest<
        ThunkReturnType<ResourceResponse<ID>>,
        Pick<IbanXsBanksRecipientsPivot, 'coreId'>
    >({
        thunk: deleteIbanXsBanksRecipientsPivotThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetIbanXsBanksRecipientsPivot
    });

    return {
        getIbanXSBanksRecipientsPivot,
        createIbanXSBanksRecipientsPivot,
        updateIbanXSBanksRecipientsPivot,
        deleteIbanXSBanksRecipientsPivot,
        downloadCsv
    };
};

export default useIbanXSBanksRecipientsPivotActions;
